import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Settings } from '@salesforce/design-system-react';
import { Modal, Button } from '@devforce/tds-react';
import { buildScopeTranslate } from 'lib/I18n';
import WithIconSettings from 'components/utils/withIconSettings';

Settings.setAppElement('#main-wrapper');

const t = buildScopeTranslate('views.my_trailhead.subdomains');

const setupSifmModal = ({nextPageUrl, id}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleNextPage = () => {
    setModalOpen(false);
    window.open(nextPageUrl, '_self');
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const renderModal = () => (
    <Modal
      id={id}
      isOpen={isModalOpen}
      heading={t("myth_id.setup.sifm_modal.title")}
      onRequestClose={() => setModalOpen(false)}
      containerClassName="slds-modal_prompt"
      headerClassName="slds-theme_error"
      footer={[
        <Button
          key={t("dictionary.cancel")}
          label={t("dictionary.cancel")}
          variant="neutral"
          onClick={handleCancel}
        />,
        <Button
          key={t("myth_id.setup.sifm_modal.button_text")}
          label={t("myth_id.setup.sifm_modal.button_text")}
          variant="brand"
          onClick={handleNextPage}
        />,
      ]}
      size="small"
      role="alertdialog"
    >
      <div className="slds-p-around_xx-large slds-text-body_regular slds-align_absolute-center">
        <p>
          {t("myth_id.setup.sifm_modal.description")}{" "}
          <a
            href="https://help.salesforce.com/articleView?id=sf.mth_considerations_for_choosing_mytrailhead_identity.htm&type=5"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("myth_id.tell_me_more_text")}
          </a>
        </p>
      </div>
    </Modal>
  );

  /* eslint-disable quotes */
  return (
    <>
      <Button label={t('myth_id.setup.sifm_button_text')} variant="brand" onClick={openModal} />
      {renderModal()}
    </>
  );
  /* eslint-enable quotes */
};

const WrappedComponent = WithIconSettings(setupSifmModal);

WrappedComponent.propTypes = {
  id: PropTypes.string,
  nextPageUrl: PropTypes.string.isRequired,
};

export default WrappedComponent;
